"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PanelModule = _interopRequireDefault(require("./Panel.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Panel = function Panel(_ref) {
  var _cx;

  var variant = _ref.variant,
      children = _ref.children,
      padding = _ref.padding,
      className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      El = _ref.as,
      props = _objectWithoutProperties(_ref, ["variant", "children", "padding", "className", "forwardedRef", "as"]);

  return _react.default.createElement(El, _extends({
    className: (0, _classnames.default)((_cx = {}, _defineProperty(_cx, "".concat(className, " ").concat(_PanelModule.default.panel), true), _defineProperty(_cx, _PanelModule.default.padding, padding), _defineProperty(_cx, _PanelModule.default[variant], variant), _cx)),
    ref: forwardedRef
  }, props), children);
};

Panel.Title = function (_ref2) {
  var className = _ref2.className,
      withPadding = _ref2.withPadding,
      props = _objectWithoutProperties(_ref2, ["className", "withPadding"]);

  return _react.default.createElement("div", _extends({}, props, {
    className: (0, _classnames.default)(_PanelModule.default.header, className, withPadding && _PanelModule.default.padding)
  }));
};

Panel.Content = function (_ref3) {
  var className = _ref3.className,
      withPadding = _ref3.withPadding,
      props = _objectWithoutProperties(_ref3, ["className", "withPadding"]);

  return _react.default.createElement("div", _extends({}, props, {
    className: (0, _classnames.default)(_PanelModule.default.content, className, withPadding && _PanelModule.default.padding)
  }));
};

process.env.NODE_ENV !== "production" ? Panel.propTypes = {
  variant: _propTypes.default.oneOf(['modal']),
  padding: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.any.isRequired
} : void 0;
Panel.defaultProps = {
  variant: undefined,
  padding: false,
  className: '',
  as: 'div'
};
var _default = Panel;
exports.default = _default;